export default [
    {
        path: "ticket",
        menu: { title: "data.ticket.mTitle", i18n: true },
        permit: "peform.ticketmonitor",
        name: "ticket",
        component: () => import("./ticket")
    }
];
